export default {
    back: 'Tilbake',
    edit: 'Rediger',
    order_detail: 'Detaljer',
    contact: 'Kontakt informasjon',
    change_contact: 'Endring Kontaktinformasjon',
    change_vehicle: 'Endring Kjøretøy',
    name: 'Navn',
    given_name: 'Fornavn',
    family_name: 'Etternavn',
    email: 'E-post',
    phone_number: 'Mobilnr.',
    address: 'Addresse',
    locality: 'Poststed',
    postal_code: 'Postnr.',
    country_code: 'Land',
    support: 'Support',
    booking_number: 'Billettnr.',
    created_at: 'Bestilt dato/-tid',
    cancelled_at: 'Avbestilt dato/-tid',
    status: 'Status',
    financial_status: 'Finansiell status',
    travel_status: 'Reise status',
    support_status: 'Support status',
    list_price_total: 'Full pris',
    discount_total: 'Rabatt',
    net_price_total: 'Nettopris totalt',
    cancellation_fee_total: 'Avbestillingsavgift',
    insurance_fee_total: 'Forsikringsavgift',
    change_fee_total: 'Endringsavgift',
    manual_fee_total: 'Manuel avgift',
    fee_total: 'Avgift totalt',
    total: 'Totalt',
    paid_total: 'Betalt totalt',
    template: 'Billettype',
    outstanding_amount: 'Utestående beløp',
    discount_code: 'Rabatt kode',
    client_id: 'Salgskanal',
    refund_success: 'Refusjon vellykket',
    refund_amount: 'Refusjonsbeløp',
    refund: 'Refusjon',
    gateway: 'Betalt via',
    type: 'Type',
    amount: 'Beløp',
    currency: 'Valuta',
    transactions: 'Transaksjoner',
    date: 'Dato',
    cancel_leg: 'Avbestill strekningen',
    cancel_leg_desc: 'Er du sikker på at du vil avbestille den valgte strekningen?',
    cancel: 'Avbestill hele billetten',
    cancel_desc: 'Er du sikker på at du vil avbestille hele billetten? NB! hvis dette er en tur/retur billett så avbestilles begge retninger.',
    departure: 'Avgangssted/-dato/-tid',
    arrival: 'Ankomststed/ -dato/-tid',
    vechile_type: 'Båt/buss',
    route: 'Rutenr.',
    failed: 'Mislyktes',
    download_pdf: 'PDF',
    send_email: 'Send billett på e-post',
    send_success: 'E-post sendt.',
    incorrect_amount: 'Beløpet er ikke tillatt',
    add_fee: 'Juster avgift +/-',
    add_fee_success: 'Avgift ble lagt til',
    passengers: 'Passasjerer',
    ticket_products: 'Billettprodukter',
    fees: 'Avgift',
    ticket_prices: 'Billettpriser',
    total_prices: 'Totale priser',
    list_price: 'Listepris',
    discount: 'Rabatt',
    net_price: 'Nettopris',
    quantity: 'Antall',
    ticket_tax_total: 'Billett MVA totalt',
    ticket_total: 'Billett totalt',
    tax_total: 'Sum MVA',
    cancellation: 'Avbestilling',
    insurance: 'Forsikring',
    manual: 'Manuelt',
    selected_leg: 'Valgt strekning',
    add_leg_fee: 'Juster avgift for strekningen',
    add_leg_fee_success: 'Avgift ble lagt til',
    calculate_cancellation_fee: 'Beregn avbestillingavgift',
    original_ticket_total: 'Opprinnelig billett totalt',
    percentage: 'Prosentandel av total billett',
    time_to_departure: 'Tid før avreise',
    registration_number: 'Registreringsnr.',
    make: 'Merke',
    model: 'Modell',
    color: 'Farge',
    vehicles: 'Kjøretøy',
    vehicle: 'Kjøretøy',
    gateway_transaction_id: 'Transaksjon id',
    gateway_order_id: 'Order id',
    locale: 'Språk',
    change_vehicle_success: 'Kjøretøy ble endret',
    change_contact_success: 'Kontaktinformasjon ble endret',
    update: 'Oppdater',
    note: 'Notat',
    add_note: 'Legg til notat',
    add_note_success: 'Notat ble lagt til',
    error_phone_number: 'Mobiltelefon nummer er ikke gyldig',
}